import React from "react";

export default function Hero() {
  return (
    <section className="hero" id="home" aria-label="CMT Prep Courses">
      <div className="hero__bg"></div>
      <div className="container hero__content">
        <h1 className="hero__title">CMT PREP COURSES</h1>
        <p className="hero__subtitle">
          Prep for CMT Levels I–III with exam-focused training rooted in technical analysis, risk management, and professional practice. The CMT Program expects you to show up confident, prepared, and ethical.
        </p>
        <div className="hero__actions">
          <a href="#contact" className="btn btn--primary">Learn More</a>
        </div>
      </div>
    </section>
  );
}
